import React from "react";
import { Provider } from "react-redux";
import store from "./core/redux/store";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import AllRoutes from "./Router/router";
import AuthStore from "./Store/auth/auth";
import refreshApi from "./Store/auth/refresh";
import AuthProvider from "react-auth-kit";
import { ConfigProvider } from "antd";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#fec639",
        },
      }}
    >
      <Provider store={{ ...store }}>
        <AuthProvider store={AuthStore} refresh={refreshApi}>
          <BrowserRouter basename={base_path}>
            <AllRoutes />
          </BrowserRouter>
        </AuthProvider>
      </Provider>
    </ConfigProvider>
  );
}
export default App;
